var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.599,
    height: 27.031,
    viewBox: "0 0 20.599 27.031",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6015",
    "data-name": "Group 6015",
    transform: "translate(-7913.475 -428.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6014",
    "data-name": "Group 6014",
    transform: "translate(7913.475 429.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M7919.433,470.6h18.644c-.021.283-.033.551-.058.817q-.517,5.569-1.036,11.139c-.173,1.868-.34,3.737-.519,5.6a1.79,1.79,0,0,1-1.861,1.687q-5.845,0-11.687,0a1.8,1.8,0,0,1-1.868-1.719q-.776-8.372-1.556-16.744C7919.467,471.134,7919.454,470.886,7919.433,470.6Zm12.593,13.943h0a3.736,3.736,0,0,0-.044.85.98.98,0,0,0,.32.621.945.945,0,0,0,1.5-.769c.153-2.226.317-4.45.475-6.676q.122-1.74.228-3.481c.024-.413-.159-.72-.494-.752-.785-.075-1.331-.126-1.348.973,0,.083-.008.166-.014.249Q7932.339,480.046,7932.026,484.538Zm-8.881-7.3h0q.284,4.031.566,8.062c.046.674.308.872,1.118.827.526-.029.745-.316.7-.931q-.157-2.291-.318-4.581-.192-2.753-.387-5.5c-.044-.607-.258-.8-.853-.8h-.214c-.545.008-.782.248-.755.8C7923.047,475.814,7923.1,476.524,7923.145,477.235Zm6.524,2.986q0-2.548,0-5.1c0-.29-.031-.626-.314-.694a2.586,2.586,0,0,0-1.167-.019c-.339.081-.349.459-.348.782q.007,2.744,0,5.488c0,1.532-.012,3.065.012,4.6a1,1,0,0,0,.268.685,1.15,1.15,0,0,0,1.154.083c.353-.126.395-.458.394-.8C7929.667,483.571,7929.669,481.9,7929.669,480.221Z",
    transform: "translate(-7918.442 -463.815)",
    fill: "#f16521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M7934.067,453.591h-20.593a13.823,13.823,0,0,1,.12-1.634,1.47,1.47,0,0,1,1.318-1.085,3.35,3.35,0,0,1,.356-.012q8.518,0,17.037.01a2.372,2.372,0,0,1,1.047.258,1.337,1.337,0,0,1,.709,1.168C7934.085,452.71,7934.067,453.125,7934.067,453.591Z",
    transform: "translate(-7913.475 -448.361)",
    fill: "#f16521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M7957.9,432.755a2.09,2.09,0,0,1-.014-.3,1.422,1.422,0,0,0-1.4-1.534c-.983-.046-1.973-.044-2.957,0a1.428,1.428,0,0,0-1.412,1.522v.347h-1.14a2.216,2.216,0,0,1,1.112-2.477,3.835,3.835,0,0,1,1.481-.434c.957-.067,1.923-.034,2.885-.015a2.622,2.622,0,0,1,2.513,1.763,5.37,5.37,0,0,1,.068,1.147C7958.662,432.769,7958.289,432.771,7957.9,432.755Z",
    transform: "translate(-7944.684 -430.834)",
    fill: "#f16521",
    fillRule: "evenodd"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-icon.03a500957fce130794840d618f1cef50.svg";